<template>
  <div class="features-page">
    <!-- Header -->
    <section class="page-header">
      <div class="container">
        <span class="section-eyebrow animate-on-scroll">FEATURES</span>
        <h1 class="animate-on-scroll aos-delay-1">功能特性</h1>
        <p class="animate-on-scroll aos-delay-2">从记录到回顾，MookNote 为你打理每一份热爱</p>
      </div>
    </section>

    <!-- Feature Detail: Movies -->
    <section class="feature-detail">
      <div class="container">
        <div class="detail-row animate-on-scroll">
          <div class="detail-content">
            <span class="detail-num">01</span>
            <h2>影视记录</h2>
            <p class="detail-desc">从经典老片到院线新作，电影、剧集、动漫、纪录片一网打尽，每一部值得记住的作品都不会错过。</p>
            <div class="detail-features">
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
                </div>
                <div class="df-text">
                  <h4>三种观看状态</h4>
                  <p>想看、在看、已看，清晰分类管理观影清单</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                </div>
                <div class="df-text">
                  <h4>影评与评分</h4>
                  <p>短评长评皆宜，星级评分生成个人观影排行榜</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                </div>
                <div class="df-text">
                  <h4>海报墙</h4>
                  <p>瀑布流海报墙与多海报管理，视觉体验拉满</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                </div>
                <div class="df-text">
                  <h4>在线搜索与豆瓣抓取</h4>
                  <p>一键搜索影视资源，自动填充资料，预告片可在线播放</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="mockup-phone">
              <div class="mp-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                <span>影视</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </div>
              <div class="mp-tabs">
                <span class="active">影视</span><span>阅读</span><span>游戏</span><span>笔记</span>
              </div>
              <div class="mp-filters">
                <span>想看</span><span class="active">已看</span><span>在看</span>
              </div>
              <div class="mp-grid">
                <div class="mp-card">
                  <div class="mp-card-img mp-movie-1"></div>
                  <span>楚门的世界</span>
                  <small>★ 9.5</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-movie-2"></div>
                  <span>我的三体</span>
                  <small>★ 9.0</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-movie-3"></div>
                  <span>仙剑奇侠传</span>
                  <small>★ 9.0</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-movie-4"></div>
                  <span>这个杀手不太冷</span>
                  <small>★ 8.9</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Feature Detail: Reading -->
    <section class="feature-detail alt">
      <div class="container">
        <div class="detail-row reverse animate-on-scroll">
          <div class="detail-content">
            <span class="detail-num">02</span>
            <h2>阅读管理</h2>
            <p class="detail-desc">追踪阅读进度，建立个人书库。书摘按章节归档，让每一本读过的书都有迹可循。</p>
            <div class="detail-features">
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
                </div>
                <div class="df-text">
                  <h4>阅读状态追踪</h4>
                  <p>想读、在读、已读，一目了然地管理阅读计划</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                </div>
                <div class="df-text">
                  <h4>书摘与批注</h4>
                  <p>按章节管理摘录与批注，积累属于自己的知识库</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                </div>
                <div class="df-text">
                  <h4>书评撰写</h4>
                  <p>短评长评自由书写，记录每一次阅读的思考</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                </div>
                <div class="df-text">
                  <h4>海量书籍数据</h4>
                  <p>对接 300 万+ 书籍基础信息，搜索即可快速建档</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="mockup-phone">
              <div class="mp-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                <span>阅读</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </div>
              <div class="mp-tabs">
                <span>影视</span><span class="active">阅读</span><span>游戏</span><span>笔记</span>
              </div>
              <div class="mp-filters">
                <span>想读</span><span class="active">在读</span><span>已读</span>
              </div>
              <div class="mp-grid">
                <div class="mp-card">
                  <div class="mp-card-img mp-book-1"></div>
                  <span>黄金时代</span>
                  <small>★ 9.3</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-book-2"></div>
                  <span>你的孤独，虽败犹荣</span>
                  <small>★ 9.4</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-book-3"></div>
                  <span>周国平散文精选</span>
                  <small>★ 9.5</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-book-4"></div>
                  <span>三体</span>
                  <small>★ 9.0</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Feature Detail: Games -->
    <section class="feature-detail">
      <div class="container">
        <div class="detail-row animate-on-scroll">
          <div class="detail-content">
            <span class="detail-num">03</span>
            <h2>游戏收藏</h2>
            <p class="detail-desc">数字版、实体版、订阅制分类管理，记录平台、价格与游玩时长，收藏每一段冒险旅程。</p>
            <div class="detail-features">
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><line x1="15" y1="13" x2="15.01" y2="13"/><line x1="18" y1="11" x2="18.01" y2="11"/><path d="M17.32 5H6.68a4 4 0 0 0-3.98 3.59l-.7 6.41a2.5 2.5 0 0 0 4.22 2.05L8.5 15h7l2.28 2.05a2.5 2.5 0 0 0 4.22-2.05l-.7-6.41A4 4 0 0 0 17.32 5z"/></svg>
                </div>
                <div class="df-text">
                  <h4>四种游玩状态</h4>
                  <p>想玩、在玩、已通关、弃坑，游戏历程清晰可溯</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <div class="df-text">
                  <h4>游玩时长记录</h4>
                  <p>记录投入的时间，见证每一段沉浸的时光</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                </div>
                <div class="df-text">
                  <h4>截图画廊</h4>
                  <p>上传游戏截图，在画廊中重温高光时刻</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                </div>
                <div class="df-text">
                  <h4>游戏评测</h4>
                  <p>撰写评测与心得，为每款游戏留下真实评价</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="mockup-phone">
              <div class="mp-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                <span>游戏</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </div>
              <div class="mp-tabs">
                <span>影视</span><span>阅读</span><span class="active">游戏</span><span>笔记</span>
              </div>
              <div class="mp-filters">
                <span>想玩</span><span class="active">在玩</span><span>已通关</span>
              </div>
              <div class="mp-grid">
                <div class="mp-card">
                  <div class="mp-card-img mp-game-1"></div>
                  <span>黑神话：悟空</span>
                  <small>★ 9.6</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-game-2"></div>
                  <span>王国之泪</span>
                  <small>★ 9.8</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-game-3"></div>
                  <span>艾尔登法环</span>
                  <small>★ 9.5</small>
                </div>
                <div class="mp-card">
                  <div class="mp-card-img mp-game-4"></div>
                  <span>星露谷物语</span>
                  <small>★ 9.2</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Feature Detail: Notes -->
    <section class="feature-detail alt">
      <div class="container">
        <div class="detail-row reverse animate-on-scroll">
          <div class="detail-content">
            <span class="detail-num">04</span>
            <h2>笔记整理</h2>
            <p class="detail-desc">Markdown 编辑实时渲染，随时记录灵感和想法。列表、瀑布流、时间线三种布局，让知识井井有条。</p>
            <div class="detail-features">
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                </div>
                <div class="df-text">
                  <h4>分享卡片</h4>
                  <p>一键生成精美分享卡片，图文并茂分享灵感</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>
                </div>
                <div class="df-text">
                  <h4>Markdown 渲染</h4>
                  <p>编辑与预览实时同步，排版优雅自然</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.83z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
                </div>
                <div class="df-text">
                  <h4>标签与置顶</h4>
                  <p>多维度标签系统，重要笔记一键置顶</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                </div>
                <div class="df-text">
                  <h4>多种布局</h4>
                  <p>列表、瀑布流、时间线，随心所欲切换视图</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="mockup-phone">
              <div class="mp-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                <span>笔记</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </div>
              <div class="mp-tabs">
                <span>影视</span><span>阅读</span><span>游戏</span><span class="active">笔记</span>
              </div>
              <div class="mp-notes">
                <div class="note-item pinned">
                  <div class="note-pin">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="10" height="10"><path d="M16 3l5 5-3 3 2 7-2 2-7-2-3 3-5-5 3-3-2-7 2-2 7 2 3-3z"/></svg>
                    置顶
                  </div>
                  <h5>九月观影小结</h5>
                  <p>这个月看了 **4 部电影**，最打动我的是《楚门的世界》——「如果再也见不到你，祝你早安，午安，晚安。」</p>
                  <div class="note-meta">
                    <span class="note-tag">影评</span>
                    <span>09-28</span>
                  </div>
                </div>
                <div class="note-item">
                  <h5>《三体》摘抄</h5>
                  <p>> 给岁月以文明，而不是给文明以岁月。</p>
                  <div class="note-meta">
                    <span class="note-tag">书摘</span>
                    <span>09-25</span>
                  </div>
                </div>
                <div class="note-item">
                  <h5>游戏清单</h5>
                  <p>- [x] 黑神话：悟空 二周目<br>- [ ] 空洞骑士：丝之歌</p>
                  <div class="note-meta">
                    <span class="note-tag">清单</span>
                    <span>09-21</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Bento: More Features -->
    <section class="more-features">
      <div class="container">
        <span class="section-eyebrow animate-on-scroll" style="text-align:center">MORE</span>
        <h2 class="section-title animate-on-scroll">不止记录</h2>
        <p class="section-subtitle animate-on-scroll">从统计回顾到个性定制，一个应用装下全部</p>
        <div class="bento-grid">
          <div class="bento-card wide animate-on-scroll">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </div>
            <h3>在线搜索</h3>
            <p>对接 6 万+ 影视、300 万+ 书籍基础数据，全局搜索与在线搜索双管齐下，建档从未如此轻松。</p>
            <div class="search-demo">
              <div class="search-bar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <span>三体</span>
              </div>
              <div class="search-result">
                <span class="sr-type">书籍</span>
                <span class="sr-name">三体 · 刘慈欣</span>
                <span class="sr-score">★ 9.3</span>
              </div>
              <div class="search-result">
                <span class="sr-type">影视</span>
                <span class="sr-name">三体（剧集）</span>
                <span class="sr-score">★ 8.7</span>
              </div>
            </div>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-1">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>
            </div>
            <h3>片单</h3>
            <p>跨媒体片单编组，影视、书籍、游戏自由组合，封面自动聚合。</p>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-2">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
            </div>
            <h3>自定义分类</h3>
            <p>表单设计器 + 自定义字段，打造专属的记录模块。</p>
          </div>
          <div class="bento-card animate-on-scroll">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            </div>
            <h3>数据统计</h3>
            <p>状态分布、类型偏好、月度活动日历、增长曲线，可视化见证热爱。</p>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-1">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </div>
            <h3>媒体日历</h3>
            <p>按日期回看添加记录，封面缩略图点缀每一天。</p>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-2">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            </div>
            <h3>图片画廊</h3>
            <p>海报、截图、图片统一浏览，支持自定义显示名称。</p>
          </div>
          <div class="bento-card animate-on-scroll">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <h3>人物与角色</h3>
            <p>导演、演员、作者自动汇总，角色档案关联作品。</p>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-1">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/><line x1="4" y1="4" x2="9" y2="9"/></svg>
            </div>
            <h3>随机漫步</h3>
            <p>随机回顾过往记录，与曾经的感动不期而遇。</p>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-2">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>
            </div>
            <h3>WebDAV 云同步</h3>
            <p>上传、下载、双向同步，支持定时自动同步到个人云盘。</p>
          </div>
          <div class="bento-card animate-on-scroll">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>
            </div>
            <h3>主题与配色</h3>
            <p>6 套配色 + Monet 动态取色，明暗主题自由切换。</p>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-1">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
            </div>
            <h3>多平台</h3>
            <p>Android、Windows 与 Linux 三端完整支持，宽屏主从布局适配。</p>
          </div>
          <div class="bento-card animate-on-scroll aos-delay-2">
            <div class="bento-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </div>
            <h3>隐私保护</h3>
            <p>数据本地存储，无需注册，不收集任何个人信息。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Tech Stack -->
    <section class="tech-stack">
      <div class="container">
        <span class="section-eyebrow animate-on-scroll" style="text-align:center">TECH STACK</span>
        <h2 class="section-title animate-on-scroll">现代技术构建</h2>
        <div class="tech-row animate-on-scroll">
          <span class="tech-item">Flutter</span>
          <span class="tech-item">Dart</span>
          <span class="tech-item">Material 3</span>
          <span class="tech-item">SQLite</span>
          <span class="tech-item">Provider</span>
          <span class="tech-item">Flask</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Features',
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.1 })

    this.$nextTick(() => {
      this.$el.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el))
    })
  }
}
</script>

<style scoped>
/* ===== Page Header ===== */
.page-header {
  padding: 170px 24px 90px;
  background:
    radial-gradient(640px 360px at 50% 0%, rgba(0, 102, 255, 0.05), transparent 70%),
    linear-gradient(180deg, #FAFAFA 0%, #FFFFFF 100%);
  text-align: center;
}

.page-header h1 {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 700;
  letter-spacing: -1px;
  margin-bottom: 16px;
  color: var(--color-text);
}

.page-header p {
  font-size: 16.5px;
  color: var(--color-text-secondary);
}

/* ===== Feature Detail ===== */
.feature-detail {
  padding: 100px 24px;
  background: #fff;
}

.feature-detail.alt {
  background: var(--color-bg-secondary);
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 88px;
}

.detail-row.reverse {
  flex-direction: row-reverse;
}

.detail-content {
  flex: 1.1;
}

.detail-num {
  display: block;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 3px;
  color: var(--color-text-muted);
  margin-bottom: 14px;
  font-variant-numeric: tabular-nums;
}

.detail-content h2 {
  font-size: clamp(28px, 3.2vw, 38px);
  font-weight: 700;
  letter-spacing: -0.5px;
  margin-bottom: 18px;
  color: var(--color-text);
}

.detail-desc {
  font-size: 15.5px;
  color: var(--color-text-secondary);
  line-height: 1.9;
  margin-bottom: 38px;
}

.detail-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 26px 24px;
}

.df-item {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.df-icon {
  width: 42px;
  height: 42px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text);
  flex-shrink: 0;
  transition: all 0.3s var(--ease-out);
}

.feature-detail.alt .df-icon {
  background: var(--color-bg-secondary);
}

.df-item:hover .df-icon {
  background: var(--color-text);
  border-color: var(--color-text);
  color: #fff;
  transform: scale(1.05);
}

.df-icon svg {
  width: 20px;
  height: 20px;
}

.df-text h4 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--color-text);
}

.df-text p {
  font-size: 13.5px;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

.detail-visual {
  flex: 1;
  display: flex;
  justify-content: center;
}

/* ===== Mockup Phone ===== */
.mockup-phone {
  width: 272px;
  background: #fff;
  border-radius: 36px;
  box-shadow:
    0 2px 4px rgba(16, 16, 20, 0.08),
    0 32px 64px -24px rgba(16, 16, 20, 0.28);
  overflow: hidden;
  border: 9px solid #161617;
  transition: transform 0.4s var(--ease-out);
}

.mockup-phone:hover {
  transform: translateY(-6px);
}

.mp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text);
}

.mp-tabs {
  display: flex;
  justify-content: center;
  gap: 22px;
  padding: 10px 0;
  font-size: 13px;
  color: var(--color-text-muted);
  border-bottom: 1px solid var(--color-border);
}

.mp-tabs .active {
  font-weight: 600;
  color: var(--color-text);
  position: relative;
}

.mp-tabs .active::after {
  content: '';
  position: absolute;
  bottom: -11px;
  left: 50%;
  transform: translateX(-50%);
  width: 18px;
  height: 2.5px;
  border-radius: 2px;
  background: var(--color-text);
}

.mp-filters {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 14px 12px;
  font-size: 12px;
}

.mp-filters span {
  padding: 5px 13px;
  border-radius: 999px;
  background: var(--color-bg-tertiary);
  color: var(--color-text-secondary);
}

.mp-filters .active {
  background: var(--color-text);
  color: #fff;
}

.mp-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 2px 14px 18px;
}

.mp-card {
  background: var(--color-bg-secondary);
  border-radius: 10px;
  overflow: hidden;
}

.mp-card-img {
  aspect-ratio: 3/4;
  background-size: cover;
  background-position: center;
}

.mp-movie-1 { background-image: url('~@/assets/img/chumendeshijie.jpg'); }
.mp-movie-2 { background-image: url('~@/assets/img/wodesanti.jpg'); }
.mp-movie-3 { background-image: url('~@/assets/img/xianjianqixiazhuan.jpg'); }
.mp-movie-4 { background-image: url('~@/assets/img/zhegeshashoubutaileng.jpg'); }

.mp-book-1 { background-image: url('~@/assets/img/book-s23122958.jpg'); }
.mp-book-2 { background-image: url('~@/assets/img/book-s27310359.jpg'); }
.mp-book-3 { background-image: url('~@/assets/img/book-s29628085.jpg'); }
.mp-book-4 { background-image: url('~@/assets/img/book-s29791128.jpg'); }

.mp-game-1 { background-image: url('~@/assets/img/heishenhua.jpg'); }
.mp-game-2 { background-image: url('~@/assets/img/saierdachuanshuo.jpg'); }
.mp-game-3 { background-image: url('~@/assets/img/eierdengfahuan.jpg'); }
.mp-game-4 { background-image: url('~@/assets/img/xinglugu.jpg'); }

.mp-card span {
  display: block;
  padding: 7px 9px 2px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mp-card small {
  display: block;
  padding: 0 9px 9px;
  font-size: 10px;
  font-weight: 600;
  color: #F5A623;
}

/* Notes mockup */
.mp-notes {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.note-item {
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px 14px;
}

.note-item.pinned {
  background: #fff;
  border-color: var(--color-border-strong);
}

.note-pin {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 600;
  color: var(--color-text-muted);
  margin-bottom: 6px;
}

.note-item h5 {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 5px;
}

.note-item p {
  font-size: 11px;
  line-height: 1.7;
  color: var(--color-text-secondary);
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.note-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  color: var(--color-text-muted);
}

.note-tag {
  padding: 2px 8px;
  background: var(--color-bg-tertiary);
  border-radius: 999px;
  font-weight: 500;
}

/* ===== Bento Grid ===== */
.more-features {
  padding: 110px 24px;
  background: #fff;
}

.bento-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 18px;
}

.bento-card {
  grid-column: span 2;
  padding: 30px 28px;
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  transition: transform 0.35s var(--ease-out), box-shadow 0.35s var(--ease-out), background 0.35s, border-color 0.35s;
}

.bento-card.wide {
  grid-column: span 4;
  grid-row: span 2;
  display: flex;
  flex-direction: column;
}

.bento-card:hover {
  transform: translateY(-5px);
  background: #fff;
  border-color: var(--color-border-strong);
  box-shadow: var(--shadow-lg);
}

.bento-icon {
  width: 46px;
  height: 46px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text);
  margin-bottom: 20px;
  transition: all 0.3s var(--ease-out);
}

.bento-card:hover .bento-icon {
  background: var(--color-text);
  border-color: var(--color-text);
  color: #fff;
  transform: scale(1.06);
}

.bento-icon svg {
  width: 22px;
  height: 22px;
}

.bento-card h3 {
  font-size: 17.5px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--color-text);
}

.bento-card p {
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.75;
}

.bento-card.wide h3 {
  font-size: 21px;
}

.bento-card.wide p {
  font-size: 15px;
  max-width: 420px;
}

/* Search demo inside wide card */
.search-demo {
  margin-top: auto;
  padding-top: 26px;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid var(--color-border-strong);
  border-radius: 12px;
  font-size: 14px;
  color: var(--color-text);
  box-shadow: var(--shadow-sm);
  margin-bottom: 10px;
}

.search-bar svg {
  color: var(--color-text-muted);
  flex-shrink: 0;
}

.search-result {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 16px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  font-size: 13px;
  margin-bottom: 8px;
  transition: border-color 0.2s, transform 0.2s var(--ease-out);
}

.search-result:hover {
  border-color: var(--color-border-strong);
  transform: translateX(4px);
}

.search-result:last-child {
  margin-bottom: 0;
}

.sr-type {
  padding: 3px 9px;
  background: var(--color-bg-tertiary);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
  flex-shrink: 0;
}

.sr-name {
  color: var(--color-text);
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sr-score {
  margin-left: auto;
  color: #F5A623;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}

/* ===== Tech Stack ===== */
.tech-stack {
  padding: 100px 24px 110px;
  background: var(--color-bg-secondary);
  border-top: 1px solid var(--color-border);
  text-align: center;
}

.tech-stack .section-title {
  margin-bottom: 44px;
}

.tech-row {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.tech-item {
  padding: 12px 26px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  font-size: 14.5px;
  font-weight: 600;
  color: var(--color-text-secondary);
  transition: all 0.3s var(--ease-out);
  cursor: default;
}

.tech-item:hover {
  color: var(--color-text);
  border-color: var(--color-text);
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
}

/* ===== Responsive ===== */
@media (max-width: 968px) {
  .detail-row,
  .detail-row.reverse {
    flex-direction: column;
    gap: 52px;
  }

  .detail-features {
    gap: 22px 18px;
  }

  .bento-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .bento-card,
  .bento-card.wide {
    grid-column: span 1;
    grid-row: auto;
  }
}

@media (max-width: 560px) {
  .page-header {
    padding-top: 150px;
  }

  .detail-features {
    grid-template-columns: 1fr;
  }

  .bento-grid {
    grid-template-columns: 1fr;
  }

  .feature-detail {
    padding: 80px 20px;
  }
}
</style>
